import React from "react";
import { useParams, Link } from "react-router-dom";
import sets from "../../data/stills.json";
import "./StillsCategory.css";

function StillsCategory() {
  const { slug } = useParams();
  const set = sets.find((s) => s.slug === slug);

  if (!set) {
    return (
      <section className="StillsCategory">
        <h1 className="StillsCategory__title">Not found</h1>
        <p>
          <Link className="StillsCategory__back" to="/stills">
            ← Back to Stills
          </Link>
        </p>
      </section>
    );
  }

  return (
    <section className="StillsCategory">
      <div className="StillsCategory__header">
        <h1 className="StillsCategory__title">{set.label}</h1>
        <Link className="StillsCategory__back" to="/stills">
          ← Back
        </Link>
      </div>

      <div className="StillsCategory__grid">
        {set.images.map((src, i) => (
          <div key={i} className="StillsCategory__tile">
            <img
              className="StillsCategory__img"
              src={src}
              alt={`${set.label} ${i + 1}`}
              loading="lazy"
            />
            <div className="StillsCategory__overlay" />
          </div>
        ))}
      </div>
    </section>
  );
}

export default StillsCategory;
